import { isFunction } from '@/global/utils/utils'
import { useGeolocationDialog } from '@/global/composables/dialogs/useGeolocationDialog'

/**
 * Wires an address field's map-pin icon to the shared geolocation picker, the
 * same way the other road maintenance screens do it. The dialog writes the
 * picked address back together with its coordinates, which is what the details
 * map panel renders its marker from.
 */
export function useWinterServiceLocation (options) {
  const { translate, createMode = false } = options || {}

  const { state, open, close } = useGeolocationDialog()

  const onLocationConfirmed = (result) => {
    // `event` is the field context handed to the dialog when it was opened - it
    // carries the form's own updateData, so the picked values land on the record
    // being edited rather than on a copy.
    const { updateData } = result?.event || {}
    if (!isFunction(updateData)) {
      close()
      return
    }

    const { address, coordinates } = result || {}

    updateData({
      address,
      latitude: coordinates?.lat ?? null,
      longitude: coordinates?.lng ?? null
    })

    close()
  }

  const openLocationDialog = (event) => {
    // The pin picks a location, so it may only do so while the form is open for
    // editing. TextField draws its append icon - and fires this - regardless of
    // edit state, so the guard has to sit here rather than on the field.
    const { editMode, createMode: isFieldInCreateMode } = event || {}
    if (!editMode && !isFieldInCreateMode) {
      return
    }

    const { latitude, longitude } = event?.formData || {}

    const dialogOptions = {
      title: translate('base.location_selection'),
      positiveButtonText: translate('base.confirm'),
      negativeButtonText: translate('base.cancel'),
      georeverseAddress: true,
      createMode,
      editMode: !createMode,
      event,
      onConfirm: onLocationConfirmed
    }

    if (latitude && longitude) {
      dialogOptions.markers = {
        lat: Number(latitude),
        lng: Number(longitude)
      }
    }

    open(dialogOptions)
  }

  return {
    state,
    openLocationDialog,
    closeLocationDialog: close
  }
}
